import React, { useEffect, useState } from 'react';
import { Box, FormControl, Grid, IconButton, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

import { MobileButton } from "../../../components";
import multiItemQuestionnaireWithLocalStorage from './MultiItemQuestionairePage.component';

import { arrayOfNumbers } from "../../../services/util.service";
import { fertilityPreservationMethods } from "../../../data/db";

import useStyles from "./MultiItemQuestionnaire.style";

import PregnancyTestIcon from "../../../images/pregnancytest.svg";

const FertilityPreservationMethodQuestionnaire = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [method, setMethod] = useState(props.data.method);
    const [otherMethod, setOtherMethod] = useState(props.data.otherMethod);

    const currentYear = new Date(Date.now()).getFullYear();
    const firstMenstruationYear = parseInt(localStorage.getItem('firstMenstruationAge') || props.firstMenstruationYear);

    useEffect(() => {
        if (method && (method === 'Other')) return;

        setOtherMethod('');
        props.onOtherMethodChange({ target: { value: '' } });
    }, [method])

    const handleMethodChange = e => {
        setMethod(e.target.value);

        props.onMethodChange(e);
    };

    const handleOtherMethodChange = e => {
        setOtherMethod(e.target.value);

        props.onOtherMethodChange(e);
    };

    return (
        <>
            <Box className={classes.questionnaire}>
                <Box className={classes.questionnaireHeader}>
                    <span>{t('common.substantive.method')} #{props.index + 1}</span>
                    <IconButton aria-label="delete" color="inherit" onClick={props.onFertilityPreservationMethodRemove}>
                        <DeleteIcon />
                    </IconButton>
                </Box>
                <Box className={classes.questionnaireBody}>
                    <Box className={classes.questionaireQuestionSet}>
                        <Box className={classes.questionnaireQuestion}>
                            {t('common.substantive.method')}
                        </Box>
                        <FormControl variant="outlined" fullWidth>
                            <Select value={method} onChange={handleMethodChange}>
                                {fertilityPreservationMethods.map(method =>
                                    <MenuItem key={method} value={method}>{method}</MenuItem>
                                )}
                            </Select>
                        </FormControl>

                    </Box>
                    {props.data.method === 'Other' &&
                        <Box className={classes.questionaireQuestionSet}>
                            <TextField
                                variant="outlined"
                                label={t('repliQuestionnaire.label.specifyMethod')}
                                fullWidth
                                value={otherMethod}
                                onChange={handleOtherMethodChange}
                            />
                        </Box>
                    }
                    <Grid container className={classes.questionaireQuestionSet}>
                        <Grid item xs={6}>
                            <Box className={classes.questionnaireQuestion}>
                                {t('common.substantive.year')}
                            </Box>
                            <FormControl variant="outlined" fullWidth>
                                <Select value={props.data.year} onChange={props.onYearChange}>
                                    {arrayOfNumbers(firstMenstruationYear, currentYear - firstMenstruationYear + 1)
                                        .map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    );
};

const Page10 = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <>
            <Box className={classes.svgIconSection}>
                <img src={PregnancyTestIcon} alt="Pregnancy Test icon" className={classes.svgIcon} style={{ width: 100 }} />
            </Box>
            <Box className={classes.textSection}>
                <Typography component="div" className={classes.text}>
                    {t('repliQuestionnaire.general.fertilityPreservationQuestion')}
                </Typography>
            </Box>
            {
                props.items.map((data, i) =>
                    <FertilityPreservationMethodQuestionnaire
                        key={i}
                        index={i}
                        data={data}
                        firstMenstruationYear={props.profile.firstMenstruationYear}
                        onFertilityPreservationMethodRemove={props.onRemove(i)}
                        onMethodChange={props.onChange(i, 'method')}
                        onOtherMethodChange={props.onChange(i, 'otherMethod')}
                        onYearChange={props.onChange(i, 'year')}
                    />
                )
            }
            <MobileButton
                label={t('common.form.button.addNew')}
                startIcon={<AddIcon />}
                onClick={props.onAdd}
            />
        </>
    );
};

const defaultFertilityPreservationMethodEntry = {
    method: '',
    otherMethod: '',
    year: '',
};

export default multiItemQuestionnaireWithLocalStorage(
    Page10,
    defaultFertilityPreservationMethodEntry,
    'fertilityPreservationMethods'
);